import { render, staticRenderFns } from "./RichWallets.vue?vue&type=template&id=7cceeafb"
import script from "./RichWallets.vue?vue&type=script&lang=js"
export * from "./RichWallets.vue?vue&type=script&lang=js"
import style0 from "./RichWallets.vue?vue&type=style&index=0&id=7cceeafb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports